import { getToken } from './user-service';
import { collection, getDocs, query, where } from "firebase/firestore";
import { firestore } from "_utils/firebase-app";

//fetching passenger booking that will make the survey
export const getBookingService = async (bookingId) => {

    return new Promise(async (resolve, reject) => {
        try {
            const token = 123456789;

            const url = `/api/v1/bookings/bookings/reviewBooking/${bookingId}`;
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Firebase-UID": token, //The user has no token, we need to add server key to make authorized
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
            });
            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw new Error("Bad request details");
            }

            resolve(json);
        } catch (e) {
            reject(new Error("Error deleting the booking"));
        }
    });
}
//fetching passenger task that will make the survey
export const getTaskService = async (taskId) => {

    return new Promise(async (resolve, reject) => {
        try {
            const collectionRef = collection(firestore, "tasks");

            // Create the first query for arrivals tasks
            const taskQuery = query(collectionRef, where("_id", "==", taskId));
            const querySnapshot = await getDocs(taskQuery);
            if (!querySnapshot.empty) {
                // Get the first document's data
                const taskData = querySnapshot.docs[0].data();

                resolve(taskData);
            } else {
                console.log("No matching task found.");
                resolve({});
            }
        } catch (error) {
            console.error("Error getting task", error);
            reject(error);
        }
    });
}

export const getQuestions = async (data) => {
    const token = data.passenger ? 123456789 : await getToken()


    let url = '/api/v1/review/survey/' + data.iata



    return new Promise(async (resolve, reject) => {

        try {

            const response = await fetch(url, { method: 'GET', headers: { "Firebase-UID": token } });
            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error("Bad details"))
            }


            resolve(json);

        } catch (e) {
            reject(new Error("error getQuestions"));
        }
    });
};


export const getSurveyIdService = async (params) => {
    const survey_url = `/api/v1/review/survey/surveyIdByIATA/${params.iata}?surveyAudience=${params.audience}`

    return new Promise(async (resolve, reject) => {
        try {
            const token = 123456789;
            const response = await fetch(survey_url, {
                method: "GET",
                headers: {
                    "Firebase-UID": token,
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
            });

            let json = await response.json();


            if (response.status >= 400 && response.status < 600) {
                console.log("error from review", json);
                throw new Error("Bad request details");
            }

            resolve(json);
        } catch (e) {
            console.log("issue posting review", e);
            reject(e);
        }
    });
};

export const postSureveyQuestionnaireService = async (data) => {
    const token = await getToken()
    let url = '/api/v1/review/survey/' + data.iata

    return new Promise(async (resolve, reject) => {

        try {

            const response = await fetch(url, {
                method: 'POST', body: JSON.stringify(data),
                headers: { "Firebase-UID": token, "Content-Type": "application/json" }
            });
            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error("Bad details"))
            }


            resolve(json);

        } catch (e) {
            reject(new Error("error saving survey questionnaire"));
        }
    });
}
export const updateSurveyAvailabilityService = async (data) => {
    const token = await getToken()
    let url = '/api/v1/review/survey/' + data.iata

    return new Promise(async (resolve, reject) => {

        try {
            const response = await fetch(url, {
                method: 'PATCH', body: JSON.stringify(data),
                headers: { "Firebase-UID": token, "Content-Type": "application/json" }
            });
            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error("Bad details"))
            }


            resolve(json);

        } catch (e) {
            reject(new Error("error saving survey questionnaire"));
        }
    });
}

export const getPaxSurveyQuestionsService = async (data) => {

    let url = `/api/v1/review/survey/paxSurvey/${data.surveyId}?language=${data.language}`;
    const token = 123456789
    return new Promise(async (resolve, reject) => {

        try {

            const response = await fetch(url, {
                method: 'GET',
                headers: { "Firebase-UID": token }
            });
            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error("Bad details"))
            }


            resolve(json);

        } catch (e) {
            reject(new Error("error getSurveyAnswersService"));
        }
    });
};


export const postSurveyAnswersService = async (data) => {

    let url = '/api/v1/review/survey/survey-answers/'

    return new Promise(async (resolve, reject) => {

        try {

            const response = await fetch(url, {
                method: 'POST', body: JSON.stringify(data),
                headers: { "Firebase-UID": 123456789, "Content-Type": "application/json" }
            });
            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error("Bad details"))
            }


            resolve(json);

        } catch (e) {
            reject(new Error("error postSurveyAnswersService"));
        }
    });
};
export const getSurveyAnswersService = async (data) => {

    const url = `/api/v1/review/survey/survey-answers/${data.iata}?surveyId=${data.surveyId}&start=${data.start}&end=${data.end}&limit=${data.limit}&skip=${data.skip}&report=${data.report}`;
    const token = await getToken()
    return new Promise(async (resolve, reject) => {

        try {

            const response = await fetch(url, {
                method: 'GET',
                headers: { "Firebase-UID": token }
            });
            const json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error("Bad details"))
            }


            resolve(json);

        } catch (e) {
            reject(new Error("error getSurveyAnswersService"));
        }
    });
};

// sent vs answered counts for the email surveys of an airport over a date range
export const getSurveySendStatsService = async (data) => {

    let url = `/api/v1/review/survey/survey-sends/stats/${data.iata}?start=${data.start}&end=${data.end}`;
    if (data.surveyId && data.surveyId !== "ALL") url += `&surveyId=${data.surveyId}`;
    const token = await getToken()
    return new Promise(async (resolve, reject) => {

        try {

            const response = await fetch(url, {
                method: 'GET',
                headers: { "Firebase-UID": token }
            });
            const json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error("Bad details"))
            }

            resolve(json);

        } catch (e) {
            reject(new Error("error getSurveySendStatsService"));
        }
    });
};